<script setup lang="ts">
import { computed, defineAsyncComponent, nextTick, onMounted, ref } from 'vue'
import { useRouter } from 'vue-router'
import { SplashScreen } from '@capacitor/splash-screen'
import { useUserStore } from '@/stores/user'
import { useNativeUI } from '@/composables/useNativeUI'
import { usePlatform } from '@/composables/usePlatform'
import AppLayout from '@/components/layout/AppLayout.vue'
import AppUpdatePrompt from '@/components/AppUpdatePrompt.vue'
import { useI18n } from 'vue-i18n'
import elementGerman from 'element-plus/es/locale/lang/de'
import elementEnglish from 'element-plus/es/locale/lang/en'

const ContactForm = defineAsyncComponent(() => import('@/components/contactFormComponent.vue'))
const LocationMap = defineAsyncComponent(() => import('@/components/locationMapComponent.vue'))
const router = useRouter()
const { locale } = useI18n()
const elementLocale = computed(() => locale.value.startsWith('en') ? elementEnglish : elementGerman)
const user = useUserStore()
const auth = computed(() => user.auth)
const contactOpen = ref(false)
const locationOpen = ref(false)
const appReady = ref(false)
const { isNative } = usePlatform()
useNativeUI(router)
onMounted(async () => {
  await router.isReady()
  appReady.value = true
  await nextTick()
  if (isNative) await SplashScreen.hide().catch(() => undefined)
})
</script>

<template>
  <el-config-provider :locale="elementLocale">
  <AppLayout v-if="appReady" :auth="auth" @contact="contactOpen = true" @location="locationOpen = true"><router-view /></AppLayout>
  <ContactForm v-if="contactOpen" v-model:contact_us="contactOpen" :auth="auth" />
  <LocationMap v-if="locationOpen" v-model:show_location="locationOpen" :auth="auth" />
  <AppUpdatePrompt v-if="isNative && appReady" />
  </el-config-provider>
</template>
